import GameBoard from "./GameBoard";

const App = () => {
    return (
        <div className="app-container">
        <GameBoard/>
        </div>
    );
}

export default App;